// Interactive "touch the ingredients" data.
export const INGREDIENTS = [
  {
    id: "saffron",
    name: "Saffron",
    urdu: "Zafran",
    color: "#8E1E1D",
    image:
      "https://images.unsplash.com/photo-1656568866961-03e9dcc0fbc6?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    fact:
      "The world's most precious spice — it takes roughly 150 flowers to make a single gram. A pinch is all our biryani needs for its golden crown.",
  },
  {
    id: "cardamom",
    name: "Green Cardamom",
    urdu: "Elaichi",
    color: "#0A4425",
    image:
      "https://images.unsplash.com/photo-1701166627787-12d9fdd437cc?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    fact:
      "The Queen of Spices. We crack the pods fresh so their sweet, floral perfume can bloom into every single grain of rice.",
  },
  {
    id: "cinnamon",
    name: "Cinnamon",
    urdu: "Dalchini",
    color: "#B45309",
    image:
      "https://images.unsplash.com/photo-1601379760622-0d2e7ad24c11?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    fact:
      "Once traded as currency between empires. Our dalchini sticks simmer whole in the korma, releasing a warm, woody sweetness.",
  },
  {
    id: "chili",
    name: "Kashmiri Chili",
    urdu: "Lal Mirch",
    color: "#B91C1C",
    image:
      "https://images.unsplash.com/photo-1625921133217-8d978f7872b8?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    fact:
      "Colour without the fear. Kashmiri chili gives our karahi that deep, glowing red — it's all flavour, gentle on the tongue.",
  },
  {
    id: "coriander",
    name: "Fresh Coriander",
    urdu: "Hara Dhania",
    color: "#166534",
    image:
      "https://images.unsplash.com/photo-1588879460618-9249e7d947d1?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    fact:
      "The final flourish. A handful of hand-torn coriander scattered at the very last second keeps every dish bright and alive.",
  },
  {
    id: "ginger",
    name: "Ginger & Garlic",
    urdu: "Adrak Lasan",
    color: "#A16207",
    image:
      "https://images.unsplash.com/photo-1630623093145-f606591c2546?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    fact:
      "The soul of desi cooking. Freshly pounded adrak-lasan is the base beneath nearly everything that leaves our kitchen.",
  },
  {
    id: "cumin",
    name: "Cumin",
    urdu: "Zeera",
    color: "#78350F",
    image:
      "https://images.unsplash.com/photo-1601723897386-e5df0c749fb7?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    fact:
      "Toasted till it crackles. That first sizzle of zeera in hot oil is the sound every desi kitchen wakes up to.",
  },
  {
    id: "turmeric",
    name: "Turmeric",
    urdu: "Haldi",
    color: "#E69C17",
    image:
      "https://images.unsplash.com/photo-1606951444141-e5533feb55be?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    fact:
      "Golden and healing. A spoon of haldi does far more than colour the pot — it's the medicine our elders always swore by.",
  },
];
